import React, { Component } from "react"
import { Mutation } from "react-apollo"
import validator from "validator"

import UPDATE_CONTACT_INFO from "../../graphql/updateContactInfo.graphql"

import "./editProfileModal.scss"

class EditProfileModal extends Component {
  state = {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dialogue: null,
    errors: {},
  }

  componentDidMount() {
    const { name, phone, email } = this.props.viewer
    const formattedName = name.split(" ")

    this.setState({
      firstName: formattedName.slice(0, formattedName.length - 1).join(" "),
      lastName: formattedName.slice(formattedName.length - 1).join(""),
      email: email,
      phone: phone,
    })
  }

  handleChange = (key, e) => {
    e.persist()

    let value = e.target.value

    if (key === "phone") {
      value = value.replace(/[^\d\+]/g, "")
    }

    this.setState(({ errors }) => ({
      [key]: value,
      dialogue: null,
      errors: { ...errors, [key]: null },
    }))
  }

  handleSave = (e) => {
    e.preventDefault()

    let requiredFields = ["email", "phone", "firstName", "lastName", "phone"]

    let { email, phone, firstName, lastName, errors } = this.state

    errors = requiredFields.reduce(
      (acc, field) => ({
        ...acc,
        [field]: this.state[field] ? undefined : "Required",
      }),
      {}
    )

    if (email && !validator.isEmail(email)) {
      errors.email = "Invalid email"
    }

    if (phone && !validator.isMobilePhone(phone, "any")) {
      errors.phone = "Invalid phone number"
    }

    if (Object.values(errors).some((v) => !!v) || !!this.state.dialogue) {
      this.setState({ errors })
      return
    }

    const name = firstName + " " + lastName

    this.props
      .updateContactInfo({ variables: { email, phone, name } })
      .then(({ data }) => {
        let { payload, message } = data.updateContactInfo.response
        if (payload === "success") {
          this.props.close()
        } else if (payload === "userAlreadyExists") {
          this.setState(({ errors }) => ({
            errors: { ...errors, email: message },
          }))
        } else {
          this.setState({
            dialogue:
              payload === "invalidInput"
                ? message
                : "An error occurred updating your profile.",
          })
        }
      })
  }

  handleCancel = (e) => {
    e.preventDefault()
    this.props.close()
  }

  render() {
    const inputData = (field) => ({
      value: this.state[field],
      error: this.state.errors[field],
      onChange: (e) => this.handleChange(field, e),
    })

    const inputFields = [
      { label: "First Name", size: "small", ...inputData("firstName") },
      { label: "Last Name", size: "small", ...inputData("lastName") },
      { label: "Email", size: "large", ...inputData("email") },
      { label: "Phone", size: "large", ...inputData("phone") },
    ]

    return (
      <div className="edit-profile-container">
        <div className="edit-profile-header">
          <h1>Edit Profile</h1>
        </div>

        <div className="edit-profile-inputs-container">
          {inputFields.map(({ label, size, error, ...inputProps }, i) => (
            <div key={i} className={`profile-input-${size}`}>
              <div className="edit-profile-input-label">
                <span>{label}:</span>
              </div>
              <input {...inputProps} />
              <div className="edit-profile-input-error">
                <span>{error}</span>
              </div>
            </div>
          ))}

          <div id="edit-profile-dialogue">
            <h4>{this.state.dialogue}</h4>
          </div>
        </div>

        <div className="edit-profile-buttons-container">
          <button id="edit-profile-save-button" onClick={this.handleSave}>
            Save
          </button>
          <button id="edit-profile-cancel-button" onClick={this.handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    )
  }
}

const EditProfileModalWithData = (componentProps) => (
  <Mutation mutation={UPDATE_CONTACT_INFO}>
    {(mutate) => (
      <EditProfileModal {...componentProps} updateContactInfo={mutate} />
    )}
  </Mutation>
)

export default EditProfileModalWithData
